import { render, staticRenderFns } from "./DataTableOrder.vue?vue&type=template&id=08271c3e&scoped=true"
import script from "./DataTableOrder.vue?vue&type=script&lang=js"
export * from "./DataTableOrder.vue?vue&type=script&lang=js"
import style0 from "./DataTableOrder.vue?vue&type=style&index=0&id=08271c3e&prod&lang=scss"
import style1 from "./DataTableOrder.vue?vue&type=style&index=1&id=08271c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08271c3e",
  null
  
)

export default component.exports